import { render, staticRenderFns } from "./OnAirPage.vue?vue&type=template&id=b036e7de&scoped=true"
import script from "./OnAirPage.vue?vue&type=script&lang=js"
export * from "./OnAirPage.vue?vue&type=script&lang=js"
import style0 from "./OnAirPage.vue?vue&type=style&index=0&id=b036e7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b036e7de",
  null
  
)

export default component.exports